import { ReactNode } from 'react'

import { StatusPillContent, StatusText } from './styles'

interface IProps {
  color: string
  children: ReactNode
}

export function Pill({ children, color }: IProps) {
  return (
    <StatusPillContent color={color}>
      <StatusText>{children}</StatusText>
    </StatusPillContent>
  )
}
